import { GuestRepository } from '../repositories/GuestRepository';
import { emit, events } from 'elc-service-bus';
import { OPT_IN_SOURCE } from '../constants/constants';

export class ContinueAsGuestUseCase {
    private guestRepository: GuestRepository;
    private email: string;

    constructor(guestRepository: GuestRepository, email: string) {
        this.guestRepository = guestRepository;
        this.email = email;
    }

    public execute = async () => {
        const guestUser = await this.guestRepository.getGuestUser();
        guestUser.setEmail(this.email);
        this.guestRepository.saveGuestUser();
        emit(events.CONTINUE_AS_GUEST_CLICKED, {
            email: this.email,
            source: OPT_IN_SOURCE.SIGN_IN
        });
    };
}
